module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "login-bg",
    attrs: {
      "src": require("../../static/img/ibroadcast/bg_guest.jpg")
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "content-form",
    attrs: {
      "type": "flex",
      "justify": "end",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "form-wrap",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10,
      "lg": 10
    }
  }, [_c('img', {
    staticClass: "form-logo",
    attrs: {
      "src": require("../../static/img/ibroadcast/zwlogo_512.png")
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.getAppVer))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "form-content",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "mt-20",
    attrs: {
      "placeholder": _vm.loginNameStr,
      "size": "large"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "mt-20",
    attrs: {
      "type": "password",
      "placeholder": _vm.loginPasswdStr,
      "size": "large"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "content-login",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onLogin('form')
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a80aee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logins/login.vue
// module id = 326
// module chunks = 2